import React from 'react';
import { Calendar, MapPin, Truck } from 'lucide-react';
import { Button } from './ui/button';

const HeroSection = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="inicio" className="hero-section pt-20">
      <div className="container mx-auto px-4 py-16 md:py-24">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 gap-8 md:gap-16 items-center">
            {/* Texto */}
            <div className="text-center md:text-left order-2 md:order-1">
              <h1 className="display-large mb-4 md:mb-6 animated fadeIn">
                Alivia tu dolor de forma natural
              </h1>
              <p className="body-large mb-6 md:mb-8 animated fadeIn delay-200ms">
                Más de 10 años de experiencia en osteopatía y terapias manuales a tu servicio.
              </p>
              <div className="flex flex-wrap gap-3 text-sm md:text-base mb-8 justify-center md:justify-start animated fadeIn delay-200ms">
                <span className="bg-[var(--brand-primary)] text-[var(--brand-dark)] px-4 py-2 rounded-full font-medium inline-flex items-center gap-2">
                  <MapPin size={16} />
                  Consulta en Fuenlabrada
                </span>
                <span className="bg-[var(--bg-card)] text-[var(--brand-dark)] px-4 py-2 rounded-full font-medium border border-[var(--border-light)] inline-flex items-center gap-2">
                  <Truck size={16} />
                  Servicio a domicilio Madrid
                </span>
              </div>
              <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start animated fadeIn delay-500ms">
                <Button 
                  className="btn-primary text-lg py-6 px-10 shadow-xl hover:scale-105 transition-transform"
                  onClick={() => scrollToSection('reservas')}
                  data-testid="hero-cta-btn"
                >
                  <Calendar className="mr-2 h-6 w-6" />
                  Reservar cita ahora
                </Button>
              </div>
              <p className="text-center md:text-left mt-6 body-medium text-[var(--text-secondary)] animated fadeIn delay-500ms inline-flex items-center gap-2 justify-center md:justify-start">
                <span className="w-2 h-2 bg-green-500 rounded-full"></span>
                Primera consulta con valoración completa
              </p>
            </div>

            {/* Imagen */}
            <div className="order-1 md:order-2 animated fadeIn">
              <div className="relative">
                <div className="absolute inset-0 bg-[var(--brand-primary)] rounded-3xl transform rotate-3 scale-95 opacity-30"></div>
                <img 
                  src="https://customer-assets.emergentagent.com/job_simple-booking-3/artifacts/xfudb9ul_Gemini_Generated_Image_5trg35trg35trg35.png"
                  alt="Raúl - Osteópata profesional"
                  className="relative rounded-3xl shadow-2xl w-full h-auto object-contain md:object-cover md:aspect-[4/5]"
                />
                <div className="absolute -bottom-4 -left-4 bg-white rounded-2xl shadow-lg p-4 hidden md:flex items-center gap-2">
                  <div className="w-3 h-3 bg-green-500 rounded-full animate-pulse"></div>
                  <span className="text-sm font-medium text-[var(--brand-dark)]">+10 años de experiencia</span>
                </div>
                <div className="absolute -top-4 -right-4 bg-[var(--brand-primary)] rounded-2xl shadow-lg p-4 hidden md:flex items-center gap-1">
                  <span className="text-yellow-500">★</span>
                  <span className="text-sm font-bold text-[var(--brand-dark)]">4.9 en Google</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
